module.exports = __webpack_public_path__ + "site/img/38.1a6411bd.jpg";